/**
 * Warehouse position kinds the scanner needs to tell apart.
 *
 * Mirrors `StoragePosition` on the server: CHK1-CHK9 hold goods waiting to be checked
 * ("na kontrolu") and BAD1-BAD9 hold damaged goods. Both are real stock that has to be
 * counted during a stock-taking, even though neither is ever offered to customers
 * (that is what `CountsTowardGoodConditionStock` governs server-side, and the server
 * derives it from exactly these prefixes).
 */
const QUARANTINE_POSITION_PREFIX = "CHK";
const DAMAGED_POSITION_PREFIX = "BAD";
/**
 * BAL + order number is the box of an order being packed (SIG-393): goods a packer scanned left their
 * shelf for it. Only the packing in Backflip changes it, so a stock-taking shows it but never counts it.
 */
const PACKING_POSITION_PREFIX = "BAL";

export type StoragePositionKind = "quarantine" | "damaged" | "packing" | "normal";

export const getStoragePositionKind = (positionId: string): StoragePositionKind => {
  if (positionId.startsWith(QUARANTINE_POSITION_PREFIX)) return "quarantine";
  if (positionId.startsWith(DAMAGED_POSITION_PREFIX)) return "damaged";
  if (positionId.startsWith(PACKING_POSITION_PREFIX)) return "packing";
  return "normal";
};

/** True for the CHK and BAD positions - the ones that do not count toward good-condition stock. */
export const isQuarantineOrDamagedPosition = (positionId: string): boolean => {
  const kind = getStoragePositionKind(positionId);
  return kind === "quarantine" || kind === "damaged";
};

/** The order number of a packing box position. */
export const packingPositionOrderCode = (positionId: string): string =>
  positionId.slice(PACKING_POSITION_PREFIX.length);
